export const HOME_FLOW = 'Home';
export const SALES_FLOW = 'Sales';
export const SERVICES_FLOW = 'Services';
